import { type UserIdVerificationResponse } from '@/features/user/types/user-id-verification-response-types';
import { type UserIdVerification } from '@/features/user/types/user-id-verification-types';

export default function userIdVerificationAdapter(userIdVerificationResponse: UserIdVerificationResponse): UserIdVerification {
  return {
    createdDate: new Date(userIdVerificationResponse.created_date),
    documentCountry: userIdVerificationResponse.document_country,
    documentType: userIdVerificationResponse.document_type,
    expiredDate: new Date(userIdVerificationResponse.expired_date),
    filledDate: userIdVerificationResponse.filled_date ? new Date(userIdVerificationResponse.filled_date) : null,
    id: userIdVerificationResponse._id,
    isExpired: userIdVerificationResponse.is_expired,
    paymentDate: new Date(userIdVerificationResponse.payment_date),
    status: userIdVerificationResponse.status,
    tosAgreedDate: new Date(userIdVerificationResponse.tos_agreed_date),
    updatedDate: new Date(userIdVerificationResponse.updated_date),
    userID: userIdVerificationResponse.user_id,
  };
}
